// Generated from l10n/locales.json. Do not edit by hand.

export interface LocaleCatalogEntry {
  id: string;
  arb: string;
  endonym: string;
  flag: string;
  language: string;
  country?: string;
  rtl: boolean;
  legacyIds: string[];
  defaultForLanguage?: string;
}

export const localeCatalog: readonly LocaleCatalogEntry[] = [
  {
    id: 'en',
    arb: 'en',
    endonym: 'English',
    flag: '🇬🇧',
    language: 'en',
    rtl: false,
    legacyIds: [],
  },
  {
    id: 'es',
    arb: 'es',
    endonym: 'Español',
    flag: '🇪🇸',
    language: 'es',
    rtl: false,
    legacyIds: [],
  },
  {
    id: 'zh-CN',
    arb: 'zh',
    endonym: '简体中文',
    flag: '🇨🇳',
    language: 'zh',
    country: 'CN',
    rtl: false,
    legacyIds: ['zh'],
  },
  {
    id: 'pt-BR',
    arb: 'pt_BR',
    endonym: 'Português (Brasil)',
    flag: '🇧🇷',
    language: 'pt',
    country: 'BR',
    rtl: false,
    legacyIds: [],
    defaultForLanguage: 'pt',
  },
  {
    id: 'pt-PT',
    arb: 'pt_PT',
    endonym: 'Português (Portugal)',
    flag: '🇵🇹',
    language: 'pt',
    country: 'PT',
    rtl: false,
    legacyIds: [],
  },
  {
    id: 'ja',
    arb: 'ja',
    endonym: '日本語',
    flag: '🇯🇵',
    language: 'ja',
    rtl: false,
    legacyIds: [],
  },
  {
    id: 'ko',
    arb: 'ko',
    endonym: '한국어',
    flag: '🇰🇷',
    language: 'ko',
    rtl: false,
    legacyIds: [],
  },
  {
    id: 'de',
    arb: 'de',
    endonym: 'Deutsch',
    flag: '🇩🇪',
    language: 'de',
    rtl: false,
    legacyIds: [],
  },
  {
    id: 'fr',
    arb: 'fr',
    endonym: 'Français',
    flag: '🇫🇷',
    language: 'fr',
    rtl: false,
    legacyIds: [],
  },
  {
    id: 'it',
    arb: 'it',
    endonym: 'Italiano',
    flag: '🇮🇹',
    language: 'it',
    rtl: false,
    legacyIds: [],
  },
  {
    id: 'ru',
    arb: 'ru',
    endonym: 'Русский',
    flag: '🇷🇺',
    language: 'ru',
    rtl: false,
    legacyIds: [],
  },
  {
    id: 'tr',
    arb: 'tr',
    endonym: 'Türkçe',
    flag: '🇹🇷',
    language: 'tr',
    rtl: false,
    legacyIds: [],
  },
  {
    id: 'id',
    arb: 'id',
    endonym: 'Bahasa Indonesia',
    flag: '🇮🇩',
    language: 'id',
    rtl: false,
    legacyIds: [],
  },
  {
    id: 'vi',
    arb: 'vi',
    endonym: 'Tiếng Việt',
    flag: '🇻🇳',
    language: 'vi',
    rtl: false,
    legacyIds: [],
  },
  {
    id: 'th',
    arb: 'th',
    endonym: 'ไทย',
    flag: '🇹🇭',
    language: 'th',
    rtl: false,
    legacyIds: [],
  },
  {
    id: 'ar',
    arb: 'ar',
    endonym: 'العربية',
    flag: '🇸🇦',
    language: 'ar',
    rtl: true,
    legacyIds: [],
  },
  {
    id: 'pl',
    arb: 'pl',
    endonym: 'Polski',
    flag: '🇵🇱',
    language: 'pl',
    rtl: false,
    legacyIds: [],
  },
  {
    id: 'nl',
    arb: 'nl',
    endonym: 'Nederlands',
    flag: '🇳🇱',
    language: 'nl',
    rtl: false,
    legacyIds: [],
  },
  {
    id: 'uk',
    arb: 'uk',
    endonym: 'Українська',
    flag: '🇺🇦',
    language: 'uk',
    rtl: false,
    legacyIds: [],
  },
  {
    id: 'cs',
    arb: 'cs',
    endonym: 'Čeština',
    flag: '🇨🇿',
    language: 'cs',
    rtl: false,
    legacyIds: [],
  },
  {
    id: 'ro',
    arb: 'ro',
    endonym: 'Română',
    flag: '🇷🇴',
    language: 'ro',
    rtl: false,
    legacyIds: [],
  },
  {
    id: 'sv',
    arb: 'sv',
    endonym: 'Svenska',
    flag: '🇸🇪',
    language: 'sv',
    rtl: false,
    legacyIds: [],
  },
  {
    id: 'da',
    arb: 'da',
    endonym: 'Dansk',
    flag: '🇩🇰',
    language: 'da',
    rtl: false,
    legacyIds: [],
  },
  {
    id: 'nb',
    arb: 'nb',
    endonym: 'Norsk bokmål',
    flag: '🇳🇴',
    language: 'nb',
    rtl: false,
    legacyIds: [],
  },
  {
    id: 'fi',
    arb: 'fi',
    endonym: 'Suomi',
    flag: '🇫🇮',
    language: 'fi',
    rtl: false,
    legacyIds: [],
  },
  {
    id: 'el',
    arb: 'el',
    endonym: 'Ελληνικά',
    flag: '🇬🇷',
    language: 'el',
    rtl: false,
    legacyIds: [],
  },
  {
    id: 'hu',
    arb: 'hu',
    endonym: 'Magyar',
    flag: '🇭🇺',
    language: 'hu',
    rtl: false,
    legacyIds: [],
  },
  {
    id: 'he',
    arb: 'he',
    endonym: 'עברית',
    flag: '🇮🇱',
    language: 'he',
    rtl: true,
    legacyIds: [],
  },
  {
    id: 'ms',
    arb: 'ms',
    endonym: 'Bahasa Melayu',
    flag: '🇲🇾',
    language: 'ms',
    rtl: false,
    legacyIds: [],
  },
  {
    id: 'sk',
    arb: 'sk',
    endonym: 'Slovenčina',
    flag: '🇸🇰',
    language: 'sk',
    rtl: false,
    legacyIds: [],
  },
  {
    id: 'bg',
    arb: 'bg',
    endonym: 'Български',
    flag: '🇧🇬',
    language: 'bg',
    rtl: false,
    legacyIds: [],
  },
  {
    id: 'hr',
    arb: 'hr',
    endonym: 'Hrvatski',
    flag: '🇭🇷',
    language: 'hr',
    rtl: false,
    legacyIds: [],
  },
  {
    id: 'sr',
    arb: 'sr',
    endonym: 'Српски',
    flag: '🇷🇸',
    language: 'sr',
    rtl: false,
    legacyIds: [],
  },
  {
    id: 'sl',
    arb: 'sl',
    endonym: 'Slovenščina',
    flag: '🇸🇮',
    language: 'sl',
    rtl: false,
    legacyIds: [],
  },
  {
    id: 'lt',
    arb: 'lt',
    endonym: 'Lietuvių',
    flag: '🇱🇹',
    language: 'lt',
    rtl: false,
    legacyIds: [],
  },
  {
    id: 'lv',
    arb: 'lv',
    endonym: 'Latviešu',
    flag: '🇱🇻',
    language: 'lv',
    rtl: false,
    legacyIds: [],
  },
  {
    id: 'et',
    arb: 'et',
    endonym: 'Eesti',
    flag: '🇪🇪',
    language: 'et',
    rtl: false,
    legacyIds: [],
  },
];

export type CatalogLocaleId = LocaleCatalogEntry['id'];

export const localeFlagEmoji: Record<string, string> = Object.fromEntries(
  localeCatalog.map((locale) => [locale.id, locale.flag]),
);

export function resolveLocale(
  raw: string | null | undefined,
  supported: readonly string[],
  browserLanguage?: string,
): string {
  const supportedSet = new Set(supported);
  const pick = (id: string | undefined): string | undefined =>
    id && supportedSet.has(id) ? id : undefined;

  if (raw) {
    const exact = pick(raw);
    if (exact) return exact;
    for (const locale of localeCatalog) {
      if (locale.legacyIds.includes(raw) || locale.arb === raw) {
        const mapped = pick(locale.id);
        if (mapped) return mapped;
      }
    }
  }

  const navigatorValue = browserLanguage ?? '';
  if (navigatorValue) {
    const [language, region] = navigatorValue.replaceAll('_', '-').split('-');
    if (region) {
      const exact = pick(`${language}-${region.toUpperCase()}`) ?? pick(`${language}-${region}`);
      if (exact) return exact;
      const compact = pick(
        `${language}-${region.charAt(0).toUpperCase()}${region.slice(1).toLowerCase()}`,
      );
      if (compact) return compact;
    }
    for (const locale of localeCatalog) {
      if (locale.defaultForLanguage === language) {
        const mapped = pick(locale.id);
        if (mapped) return mapped;
      }
    }
    const languageOnly = pick(language);
    if (languageOnly) return languageOnly;
    for (const locale of localeCatalog) {
      if (locale.language === language) {
        const mapped = pick(locale.id);
        if (mapped) return mapped;
      }
    }
  }

  return pick('en') ?? supported[0] ?? 'en';
}

export function isRtlLocale(id: string): boolean {
  return localeCatalog.some((locale) => locale.id === id && locale.rtl);
}
